const menu = {
  label: '• Naturezas',
  to: '/sol/naturezas',
  rules: ['SOL-001'],
}

export default menu;